import HelperService from "../services/helper-service";
import Section from "./section";

export default function Loading({className='', ...props}) {
    return (
        <>
            <Section animation={HelperService.getRandomAnimation()} className={`d-flex justify-content-center ${className}`}>
                <div style={{width:"60px", height:"60px"}} className={'pulsing bg-white rounded rounded-circle p-2 d-flex align-items-center shadow justify-content-center'}>
                    <img style={{width:"80%"}} src="/assets/images/logo-colored.svg" alt='loading...' />
                </div>
            </Section>
        </>
    );
}
